import Vue from 'vue'

export default Vue.extend({
  template: `
    <div :style="divStyle">
      <b-img 
        v-if="type === 'img'"
        :src="src"
        :style="imgStyle"
        @click="onImageClicked"
      />
      <div v-if="type === 'json'">
        <b-img 
          :src="src"
          :style="imgStyle"
          @click="onImageClicked"
        />
      </div>
      <audio
        controls
        v-if="type === 'audio'"
        :src="src"
      />
    </div>
  `,
  data() {
    return {
      toggled: false
    }
  },
  computed: {
    type() {
      return this.params.node.data.file.type
    },
    src() {
      let src = `/api/files/${this.params.node.data.file.physicalName}`
      if (this.type === 'json') {
        src = `/api/files/${this.params.node.data.description.imagePath}`
      }
      return src
    },
    rowHeight() {
      if (this.type !== 'audio') {
        if (this.toggled) {
          return 500
        }
        return 50
      }
      return 50
    },
    divStyle() {
      return {
        height: `${this.rowHeight}px`
      }
    },
    imgStyle() {
      return {
        'max-width': '100%',
        'max-height': '100%',
        cursor: 'pointer'
      }
    }
  },
  methods: {
    onImageClicked() {
      this.toggled = !this.toggled
      this.params.node.setRowHeight(this.rowHeight)
      this.params.context.componentParent.toggleWidth(
        this.toggled ? 1 : -1,
      )
    }
  }
})
